module.exports = __webpack_public_path__ + "img/ticon3.95550e52.png";